<template>
  <section>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          small
          v-bind="attrs"
          v-on="on"
          color="primary"
          elevation="0"
          @click.stop="onAddProduct"
        >
          <v-icon class="primary-font-color" medium>mdi-plus-thick</v-icon>
        </v-btn>
      </template>
      <span>{{ $translate('ADD') }}</span>
    </v-tooltip>

    <ProductAgeAlert
      v-model="showAgeAlert"
      :forAge="product.ForAge"
      @confirm="addProduct"
    />
  </section>
</template>

<script>
import { SHOPPING_CONTAINER } from '@/shared/constants';
import {
  bookableDirectly,
  getMinimumQuantity,
  isWeightedProduct,
} from '@/objects/Product';
import { addProductToReservation } from '@/objects/ShoppingList';
import ProductAgeAlert from '@/components/event/eventDetails/productOrderComponents/ProductAgeAlert';

export default {
  name: 'AddProductDirectlyBtn',
  props: {
    product: Object,
  },
  components: {
    ProductAgeAlert,
  },
  data() {
    return {
      showAgeAlert: false,
    };
  },
  computed: {
    selectedCartOrList() {
      return this.$store.getters.getCurrentSelectedShoppingList;
    },
    hasAgeLimit() {
      return (
        this.product != null &&
        this.product.ForAge != null &&
        Number(this.product.ForAge) > 0
      );
    },
  },
  methods: {
    onAddProduct() {
      if (!bookableDirectly(this.product)) {
        console.error(
          'Product can not be directly added to the shopping cart/list. \
          Either because it has multiple items, or has options, or is null. ',
          this.product
        );
        return;
      }

      if (this.hasAgeLimit) {
        this.showAgeAlert = true;
        return;
      }

      this.addProduct();
    },
    getItem() {
      if (!bookableDirectly(this.product)) {
        return null;
      }
      return this.product.Items[0];
    },
    getQuantity() {
      return getMinimumQuantity(this.product, this.getItem());
    },
    getReservePayload() {
      const item = this.getItem();

      if (item == null) {
        return null;
      }

      const quantity = this.getQuantity();

      const prodInfo = {
        EventType: this.product.EventType,
        EventId: this.product.EventId,
        Name: this.product.Name,
        Picture: this.product.Picture,
        Id: this.product.Id,
        ItemId: item.Id,
        ItemDefs: item.ItemDef,
        Type: this.product.Type,
        Price: item.Price,
        Quantity: quantity,
        OptionSelection: [],
        Product: this.product,
        Item: item,
      };

      if (isWeightedProduct(this.product)) {
        // Add extra info for Weighted product
        prodInfo.Price =
          (quantity / this.product.WeightedInfo.StepSize) *
          this.product.WeightedInfo.PricePerStep;
        prodInfo.Amount = quantity;
        prodInfo.Quantity = 1;
        prodInfo.FixedPrice = this.product.WeightedInfo.FixedPrice;
        prodInfo.Unit = this.product.WeightedInfo.Unit;
        prodInfo.WeightedInfo = this.product.WeightedInfo;
      }

      return prodInfo;
    },
    addProduct() {
      if (
        this.selectedCartOrList != null &&
        this.selectedCartOrList.ShoppingListId != null &&
        this.selectedCartOrList.ShoppingListId !==
          SHOPPING_CONTAINER.ShoppingCart &&
        this.selectedCartOrList.ShoppingListId !==
          SHOPPING_CONTAINER.NewShoppingList &&
        typeof this.selectedCartOrList.ShoppingListId === 'string' &&
        this.selectedCartOrList.ShoppingListId.trim() !== ''
      ) {
        this.addProductToList();
      } else {
        this.addProductToCart();
      }
    },
    addProductToCart() {
      const prodInfo = this.getReservePayload();
      if (prodInfo == null) {
        console.error(
          'Product can not be added to the shopping cart with invalid payload: ',
          prodInfo
        );
        return;
      }

      console.log(
        'Going to add product directly to the shopping cart with payload: ',
        prodInfo
      );
      this.$store.commit('shoppingCart/addOrder', prodInfo);
    },
    addProductToList() {
      const item = this.getItem();

      if (item == null) {
        console.error(
          'Product can not be added to the shopping list with invalid item: ',
          this.product
        );
        return;
      }

      const quantity = this.getQuantity();

      let orderId = '';

      if (
        this.selectedCartOrList.OrderGroup != null &&
        this.selectedCartOrList.OrderGroup.Orders != null
      ) {
        const order = this.selectedCartOrList.OrderGroup.Orders.find(
          (orderInList) =>
            String(orderInList.EventId) === String(this.product.EventId)
        );
        if (order != null) {
          orderId = order.OrderId;
        }
      }

      const payload = {
        ShoppingListId: this.selectedCartOrList.ShoppingListId,
        OrderId: orderId,
        EventId: this.product.EventId,
        ProductId: this.product.Id,
        ItemId: item.Id,
        Quantity: quantity,
        OptionSelection: [],
      };

      addProductToReservation(payload)
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>
